import React from 'react';
import { Container } from 'react-bootstrap';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const lastUpdated = '19.03.2026';

  return (
    <div className="privacy-page">
      <Container fluid className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        <div className="privacy-card">
          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">1.</span> Introduction
            </h2>
            <p className="privacy-body">
              This Privacy Policy explains how we collect, use, and protect your personal information when you visit or make a purchase from our website. By using our website, you agree to the terms outlined here.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">2.</span> Information We Collect
            </h2>
            <p className="privacy-body">We may collect the following types of information:</p>
            <ul className="privacy-list">
              <li>
                <strong>Personal Information:</strong> Name, phone number, email address, billing and shipping address, and payment details (processed securely by payment partners).
              </li>
              <li>
                <strong>Non-Personal Information:</strong> Device information, browser type, IP address, and cookies and website usage data.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">3.</span> How We Use Your Information
            </h2>
            <p className="privacy-body">Your information is used for:</p>
            <ul className="privacy-list">
              <li>Processing and delivering orders</li>
              <li>Sending order confirmations, updates, and support messages</li>
              <li>Improving website performance and customer experience</li>
              <li>Preventing fraud and ensuring secure transactions</li>
              <li>Marketing updates (only with your consent)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">4.</span> Sharing of Information
            </h2>
            <p className="privacy-body">We do not sell or rent your personal information.</p>
            <p className="privacy-body">We may share your information only with:</p>
            <ul className="privacy-list">
              <li>Delivery partners for order shipping</li>
              <li>Payment gateways for secure payments</li>
              <li>Service providers who support website operations</li>
            </ul>
            <p className="privacy-body">All third-party partners follow strict data protection standards.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">5.</span> Data Security
            </h2>
            <p className="privacy-body">
              We take reasonable security measures to protect your information from unauthorized access, misuse, or disclosure. However, no online system is 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">6.</span> Cookies
            </h2>
            <p className="privacy-body">Our website uses cookies to:</p>
            <ul className="privacy-list">
              <li>Improve browsing experience</li>
              <li>Remember preferences</li>
              <li>Analyze website traffic</li>
            </ul>
            <p className="privacy-body">You may choose to disable cookies in your browser settings.</p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">7.</span> Your Rights
            </h2>
            <p className="privacy-body">You have the right to:</p>
            <ul className="privacy-list">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information (subject to legal/operational requirements)</li>
              <li>Opt out of marketing communications at any time</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">8.</span> Third-Party Links
            </h2>
            <p className="privacy-body">
              Our website may contain links to third-party websites. We are not responsible for their privacy practices or content.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">9.</span> Changes to This Policy
            </h2>
            <p className="privacy-body">
              We may update this Privacy Policy at any time. Changes will be posted on this page, and continued use of our website constitutes acceptance of the updated policy.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-section-heading">
              <span className="privacy-section-num">10.</span> Contact Us
            </h2>
            <p className="privacy-body">
              For questions about this Privacy Policy or to request data access or deletion, please contact our support team.
            </p>
          </section>

          <p className="privacy-last-updated">Last Updated on: {lastUpdated}</p>
        </div>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
